import { User } from 'lucide-react';
import type { UnidadFlota } from '@tms/contratos';
import { fmtHace, fmtKmh, minutosDesde } from '../util/format';
import { Insignia } from './ChipEstado';
import { UNIDAD } from './estados';

interface Props {
  unidad: UnidadFlota;
  seleccionada: boolean;
  ahora: number;
  onSeleccionar: (u: UnidadFlota) => void;
}

/** Tarjeta de la lista de unidades (panel izquierdo de la torre). */
export function TarjetaUnidad({ unidad: u, seleccionada, ahora, onSeleccionar }: Props) {
  const v = u.viaje;
  const chofer = v?.choferPrincipal ?? u.vivo?.operadorNombre ?? 'Sin chofer asignado';
  const color = UNIDAD[u.estado].color;

  let pie: string;
  if (u.estado === 'EN_RUTA') pie = fmtKmh(u.vivo?.velocidadKmh);
  else if (u.estado === 'DETENIDA') {
    const min = minutosDesde(u.vivo?.detenidoDesde, ahora);
    pie = min === null ? 'Detenida' : `Detenida hace ${min} min`;
  } else if (u.estado === 'SIN_REPORTE') pie = u.vivo ? `Sin reporte ${fmtHace(u.vivo.ultimoReporte, ahora)}` : 'Sin reportar';
  else pie = 'Sin actividad';

  return (
    <button
      type="button"
      className={`unit ${seleccionada ? 'selected' : ''}`}
      aria-pressed={seleccionada}
      onClick={() => onSeleccionar(u)}
    >
      <div className="unit-top">
        <span>
          <strong>{u.patente ?? u.vehiculoIdMicrotrack}</strong>
          {u.interno && <span className="internal">#{u.interno}</span>}
        </span>
        <Insignia tipo="unidad" valor={u.estado} />
      </div>
      <div className="unit-driver">
        <User aria-hidden />
        {chofer}
      </div>
      {v ? (
        <>
          <div className="unit-line">
            <span>
              {v.idMara} · {v.empresa ?? '—'}
            </span>
            <span>{v.unidadNegocio ?? '—'}</span>
          </div>
          <div className="unit-line">
            <span>
              {v.origenNombre ?? '—'} → {v.destinoNombre ?? '—'}
            </span>
          </div>
        </>
      ) : (
        <div className="unit-line">
          <span>Sin viaje asignado</span>
        </div>
      )}
      <div className="unit-bottom">
        <span className="muted">
          {v ? (
            <>
              {v.estado === 'PLANIFICADO' ? 'Viaje planificado · ' : ''}
              {v.rutaNombre === null ? <span className="amber">Sin ruta</span> : `${v.paradasCumplidas}/${v.paradasTotal} paradas`}
            </>
          ) : (
            '—'
          )}
          {u.alertasAbiertas > 0 && <span className="alertas-n"> · {u.alertasAbiertas} novedad{u.alertasAbiertas > 1 ? 'es' : ''}</span>}
        </span>
        <span className={color === 'brand' ? 'green' : color}>{pie}</span>
      </div>
    </button>
  );
}
